import { render, staticRenderFns } from "./ExportarButton.vue?vue&type=template&id=0dd1b595&scoped=true&"
import script from "./ExportarButton.vue?vue&type=script&lang=ts&"
export * from "./ExportarButton.vue?vue&type=script&lang=ts&"
import style0 from "./ExportarButton.vue?vue&type=style&index=0&id=0dd1b595&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd1b595",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('0dd1b595', component.options)
    } else {
      api.reload('0dd1b595', component.options)
    }
    module.hot.accept("./ExportarButton.vue?vue&type=template&id=0dd1b595&scoped=true&", function () {
      api.rerender('0dd1b595', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/reusable/Grid/ExportarButton.vue"
export default component.exports